import { CUSTOM_EVENTS } from "constants/index";
import React, { Fragment } from "react";
import EventsService from "utils/eventsService";
import { getUsername } from "../../services/auth";
import Content from "./Content/content.component";
import Footer from "./Footer/footer.component";
import Header from "./Header/header.component";

class Layout extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			userName: ""
		};
	}

	setUserName() {
		this.setState({
			userName: getUsername()
		});
	}

	componentWillMount() {
		this.setUserName();

		EventsService.listenEvent(
			CUSTOM_EVENTS.UPDATE_USER,
			"userName",
			this.setUserName.bind(this)
		);
	}

	render() {
		const { children } = this.props;

		return (
			<Fragment>
				<Header username={this.state.userName} />
				<Content>{children}</Content>
				<Footer />
			</Fragment>
		);
	}
}

export default Layout;
